"use client";

import { clsx } from "@trydig/ui";
import { type PropsWithChildren, Suspense } from "react";
import { useModal } from "~/lib/hooks/useModal";
import { useSessionStore } from "~/lib/stateManagement/sessionState/sessionStore";
import styles from "./modal.module.css";

const UnsuspendedModal = ({
	modalName,
	children,
	isMenu,
}: PropsWithChildren<{
	modalName: string;
	isMenu?: boolean;
}>) => {
	const { isOpen, closeModal } = useModal(modalName, () => {});
	const atTop = useSessionStore((store) => store.atTop);

	return (
		<div
			data-open={isOpen}
			className={clsx(
				styles.container,
				!isOpen && styles.hidden,
				isMenu && styles.menu,
				isMenu && !atTop && styles.scrolled,
			)}
		>
			<div
				className={clsx(styles["mobile-overlay"], isOpen && styles.active)}
				onClick={closeModal}
			/>
			{children}
		</div>
	);
};

export const Modal: typeof UnsuspendedModal = (props) => {
	return (
		<Suspense>
			<UnsuspendedModal {...props} />
		</Suspense>
	);
};
